import { GET_SCHEDULLED_POSTS } from "../actions/scheduledPost.actions";

const initialState = {};

export default function scheduledPostReducer(state = initialState, action) {
  return action.type === GET_SCHEDULLED_POSTS ? action.payload : state;
}
